document.addEventListener('DOMContentLoaded', function () {
  var topbarSort = document.getElementById('KitabooSortBy');
  var facetSortForm = document.getElementById('FacetSortForm');
  var hiddenSort = facetSortForm ? facetSortForm.querySelector('#SortBy') : null;
  var grid = document.getElementById('product-grid');
  var usesExclusionPagination = !!(grid && grid.dataset.exclusionPagination === 'true');

  function syncSortSelects(value, source) {
    document.querySelectorAll('#SortBy, #KitabooSortBy, #SortBy-mobile').forEach(function (el) {
      if (!el || el === source) return;
      el.value = value;
    });
  }

  function pushSortToUrl(value) {
    var params = new URLSearchParams(window.location.search);
    params.set('sort_by', value);
    params.delete('page');
    params.forEach(function (paramValue, key) {
      if (key.indexOf('filter.') === 0 && !paramValue) {
        params.delete(key);
      }
    });
    var query = params.toString();
    history.pushState({ searchParams: query }, '', window.location.pathname + (query ? '?' + query : ''));
  }

  function navigateWithSort(value) {
    var params = new URLSearchParams(window.location.search);
    params.set('sort_by', value);
    params.delete('page');
    params.forEach(function (paramValue, key) {
      if (key.indexOf('filter.') === 0 && !paramValue) {
        params.delete(key);
      }
    });
    var query = params.toString();
    window.location.assign(window.location.pathname + (query ? '?' + query : ''));
  }

  function refreshCollectionView() {
    if (
      usesExclusionPagination &&
      window.KitabooExclusionPagination &&
      typeof window.KitabooExclusionPagination.refreshCollectionView === 'function'
    ) {
      window.KitabooExclusionPagination.refreshCollectionView();
      return true;
    }
    return false;
  }

  function handleSortChange(value, source) {
    syncSortSelects(value, source);
    if (hiddenSort) hiddenSort.value = value;

    if (usesExclusionPagination) {
      pushSortToUrl(value);
      refreshCollectionView();
      return;
    }

    navigateWithSort(value);
  }

  if (topbarSort) {
    if (hiddenSort) topbarSort.value = hiddenSort.value;
    topbarSort.addEventListener('change', function () {
      handleSortChange(topbarSort.value, topbarSort);
    });
  }

  document.querySelectorAll('#SortBy').forEach(function (sortSelect) {
    if (!sortSelect || sortSelect === topbarSort) return;
    sortSelect.addEventListener('change', function () {
      handleSortChange(sortSelect.value, sortSelect);
    });
  });

  document.querySelectorAll('#SortBy-mobile').forEach(function (sortSelect) {
    if (!sortSelect) return;
    sortSelect.addEventListener('change', function () {
      handleSortChange(sortSelect.value, sortSelect);
    });
  });
});
